import { createSlice } from '@reduxjs/toolkit';

import axios from 'utils/axiosClient';
import { dispatch } from '../index';

const initialState = {
    // 9 nơi thực tập, đúng thứ tự ban quản lý đưa.
    noiThucTap: [],
    // Dòng của chính hạnh sinh trong danh sách Trung Minh; null = không thuộc danh sách.
    phieu: null,
    canEdit: false,
    loaded: false,
    saving: false,
    error: null,
    dialogOpen: false
};

const slice = createSlice({
    name: 'dangKyThucTap',
    initialState,
    reducers: {
        // Đổi tài khoản trong cùng tab: store là module-level và không persist, nên state của
        // người trước còn nguyên trong RAM sau khi đăng xuất. Đặt lại TOÀN BỘ về mặc định.
        datLai() {
            return { ...initialState };
        },
        // Chỉ dùng cho LỖI TẢI (lỗi gửi có `saveFailure` riêng, cố ý KHÔNG xoá `phieu` để
        // popup đang mở không biến mất giữa chừng).
        hasError(state, action) {
            state.error = action.payload;
            state.loaded = true;
            // Xoá dữ liệu của lần tải trước: nếu hạnh sinh khác vừa đăng nhập mà request
            // hỏng, không được để họ nhìn thấy phiếu của người trước.
            state.noiThucTap = [];
            state.phieu = null;
            state.canEdit = false;
        },
        getHienTaiSuccess(state, action) {
            state.noiThucTap = action.payload?.noiThucTap ?? [];
            state.phieu = action.payload?.phieu ?? null;
            state.canEdit = action.payload?.canEdit === true;
            state.loaded = true;
            state.error = null;
        },
        saveStart(state) {
            state.saving = true;
            state.error = null;
        },
        saveSuccess(state, action) {
            state.phieu = action.payload;
            state.saving = false;
            state.dialogOpen = false;
        },
        saveFailure(state, action) {
            state.saving = false;
            state.error = action.payload;
        },
        moDialog(state) {
            state.dialogOpen = true;
        },
        dongDialog(state) {
            state.dialogOpen = false;
        }
    }
});

export default slice.reducer;

export const { datLai, moDialog, dongDialog } = slice.actions;

// TẠM ẨN (18/09/2026): hạnh sinh không muốn đăng ký thực tập nữa. Không gọi API, coi như
// "không có phiếu" — popup, nút trang chủ, mục menu và trang đều tự ẩn theo `phieu = null`.
// Vẫn phải đánh dấu `loaded` vì ThongBaoTrangChu chờ cờ này. Mở lại: đổi thành false.
export const TAM_AN_DANG_KY_THUC_TAP = true;

// Đăng ký thực tập là việc phụ: mọi lỗi ở đây chỉ ghi vào state, không được nổi lên màn
// hình và không được làm hỏng trang chủ.
export function getDangKyThucTapHienTai() {
    return async () => {
        if (TAM_AN_DANG_KY_THUC_TAP) {
            dispatch(slice.actions.getHienTaiSuccess(null));
            return;
        }

        try {
            const response = await axios.get('/dangkythuctap/current');
            dispatch(slice.actions.getHienTaiSuccess(response));
        } catch (error) {
            dispatch(slice.actions.hasError(error?.message || 'Không tải được thông tin đăng ký thực tập.'));
        }
    };
}

export function saveDangKyThucTap(noiThucTap) {
    return async () => {
        dispatch(slice.actions.saveStart());

        try {
            const response = await axios.post('/dangkythuctap', { noiThucTap });
            dispatch(slice.actions.saveSuccess(response));
            return { ok: true };
        } catch (error) {
            const message = error?.response?.data?.message || 'Không đăng ký được, vui lòng thử lại.';
            dispatch(slice.actions.saveFailure(message));
            return { ok: false, message };
        }
    };
}
